import { APP_CODES } from './appcodes';

export const FEATURE_FLAGS = {
  [APP_CODES.PERFORMANCE_OPTIMIZER]: 'appsPerformanceOptimizerEnabled',
  [APP_CODES.DATA_TRANSPORTER]: 'appsDataTransporterEnabled',
  [APP_CODES.CONVERSATION_ASSIST]: 'appsConversationAssistEnabled',
  [APP_CODES.AIWB]: 'appsAiwbEnabled',
  INTENT_MANAGER_LOGIN_BY_API: 'appsIntentManagerLoginByApiEnabled',
  INTENT_MANAGER_INTENT_BUILDER_CRUDS_ENABLED: 'appsIntentManagerIntentBuilderCrudsEnabled',
  CONVERSATION_BUILDER_SSO_FOR_GCP: 'appsConversationBuilderSsoForGcpEnabled',
  CONVERSATION_BUILDER_USE_CSDS: 'appsConversationBuilderUseCsds',
  CONVERATION_BUILDER_SEND_CSDS: 'appsConversationBuilderSendCsdsDataToIframes',
  CONVERSATION_BUILDER_ENCODE_UNICODE_FIELDS: 'appsConversationBuilderEncodeUnicodeFieldsInPostmessage',
};

export default FEATURE_FLAGS;
